import React, { useEffect, useState, Component } from 'react';
import { ShoppingCartIcon } from 'lucide-react';
const CAROUSEL_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/oGCnypQkmNaCZGW5m1F2U4/torta-choco.jpg',
  alt: 'Torta de chocolate'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nhMQb5J9FUy98MrpCgpnCi/torta-helada.jpg',
  alt: 'Torta helada'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/mScitXLFJBwBu3BdadS3oq/flan.jpg',
  alt: 'Flan casero'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/xdfHUPp25begmweLu4qAi6/brownie.jpg',
  alt: 'Brownie recién horneado'
}];
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
  showCarousel?: boolean;
  className?: string;
  scrollTo?: string;
}
export function CTAButton({
  text = 'SÍ, QUIERO MI DULCE LIBERTAD',
  subtext = 'Acceso inmediato • Garantía 30 días • Pago 100% seguro',
  size = 'lg',
  showIcon = true,
  showCarousel = false,
  className = '',
  scrollTo
}: CTAButtonProps) {
  const [current, setCurrent] = useState(0);
  const [fading, setFading] = useState(false);
  useEffect(() => {
    if (!showCarousel) return;
    const interval = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setCurrent(prev => (prev + 1) % CAROUSEL_IMAGES.length);
        setFading(false);
      }, 400);
    }, 3000);
    return () => clearInterval(interval);
  }, [showCarousel]);
  const sizeClasses = {
    sm: 'px-6 py-3 text-sm',
    md: 'px-8 py-4 text-base',
    lg: 'px-10 py-5 text-lg'
  };
  const handleClick = () => {
    if (scrollTo) {
      const target = document.getElementById(scrollTo);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
      return;
    }
    // Fire Facebook AddToCart event
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart');
    }
    // Read the 'src' param from the current page URL and forward it
    const urlParams = new URLSearchParams(window.location.search);
    const srcParam = urlParams.get('src');
    const baseUrl = 'https://pay.hotmart.com/S104693420O?hideBillet=1&offDiscount=80OFF';
    const finalUrl = srcParam ? `${baseUrl}&src=${encodeURIComponent(srcParam)}` : baseUrl;
    // Redirect to Hotmart checkout in new tab
    window.open(finalUrl, '_blank');
  };
  return <div className={`flex flex-col items-center gap-3 ${className}`} data-id="element-86">
      {/* Carousel — only shown when showCarousel=true */}
      {showCarousel && <div className="w-full max-w-xl rounded-2xl overflow-hidden mb-2" style={{
      aspectRatio: '16/9',
      position: 'relative'
    }} data-id="element-87">
          <img src={CAROUSEL_IMAGES[current].src} alt={CAROUSEL_IMAGES[current].alt} style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        transition: 'opacity 0.4s ease',
        opacity: fading ? 0 : 1,
        display: 'block'
      }} data-id="element-88" />
          <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-2" aria-hidden="true" data-id="element-89">
            {CAROUSEL_IMAGES.map((_, i) => <span key={i} style={{
          width: i === current ? 20 : 8,
          height: 8,
          borderRadius: 4,
          background: i === current ? 'var(--gold)' : 'rgba(255,255,255,0.5)',
          transition: 'all 0.3s ease',
          display: 'inline-block'
        }} data-id="element-90" />)}
          </div>
        </div>}

      <button onClick={handleClick} className={`btn-gold rounded-full flex items-center gap-3 ${sizeClasses[size]} font-bold uppercase tracking-wider w-full max-w-xl justify-center`} aria-label={text} data-id="element-91">
        {showIcon && <ShoppingCartIcon className="w-5 h-5 flex-shrink-0" aria-hidden="true" data-id="element-92" />}
        <span data-id="element-93">{text}</span>
      </button>
      {subtext && <p className="text-sm text-center" style={{
      color: 'var(--text-muted)'
    }} data-id="element-94">
          {subtext}
        </p>}
    </div>;
}